// services/clients.js
import { get, post , put } from './api';

const BASE = '/clients';

export const checkClientByEmail = async (email) => {
  const res = await get(`${BASE}/exists`, { params: { email } });
  return res.data.exists;
};

export const registerClient = async (clientData) => {
  const res = await post(`${BASE}/register`, clientData);
  return res.data;
};

export const loginClient = async (data) => {
  const res = await post(`${BASE}/login`, data);
  return res.data;
};

export const getClientByEmail = async (email) => {
  const res = await get(`${BASE}/by-email/${encodeURIComponent(email)}`);
  return res.data;
};

export const updateClient = async (email, clientData) => {
  const res = await put(`${BASE}/update/${encodeURIComponent(email)}`, clientData);
  return res.data;
};
